interface ReferencedFeedbackCategoryData {
	id: string;
}

export class ReferencedFeedbackCategory {
	id: string;
	type = 'FeedbackCategory';

	constructor(data: ReferencedFeedbackCategoryData) {
		this.id = data.id;
	}
}
